<template>
    <v-card>
        <template v-slot:progress>
            <v-progress-linear absolute color="blue darken-4" height="6" indeterminate></v-progress-linear>
        </template>
        <v-img height="80" src="@/assets/images/fondo1.png">
            <v-row>
                <v-row class="pa-4" align="center" justify="center">
                    <v-col class="text-center">
                        <h1 class="headline black--text">Alumno</h1>
                    </v-col>
                </v-row>
            </v-row>
        </v-img>
        <v-form ref="refMain">
            <v-container fluid>
                <v-row dense>
                    <v-col cols="9" xm="12" sm="6" md="6" class="pa-1">
                        <v-text-field @keyup.enter.prevent="fuSearch" v-model="dDNINombre" label="DNI o Codigo o Nombre" outlined prepend-inner-icon="credit_card" clearable :rules="[v => !!v || 'El campo es requerido']" :maxlength="120" counter autocomplete="off"></v-text-field>
                    </v-col>
                    <v-col cols="3">
                        <v-btn @click.prevent="fuSearch" :loading="dTable.loading" color="blue-grey" dark x-large>
                            <v-icon large left>search</v-icon>
                            Buscar por {{campoTipo}}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-form>
        <v-data-table :headers="dTable.headers" :items="dPriAlumnos" :loading="dTable.loading" :search="dTable.search" class="elevation-1">
            <template v-slot:no-data><v-alert :value="true" color="warning" icon="warning" outlined border="top">No hay registros para mostrar.</v-alert></template>
            <template v-slot:no-results><v-alert :value="true" color="warning" icon="warning">No se encontro ningun registro con su busqueda "{{ dTable.search }}".</v-alert></template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-menu bottom offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on"><v-icon>more_vert</v-icon></v-btn>
                    </template>
                    <v-list>
                        <v-list-item>
                            <v-list-item-title><v-btn @click="$router.push(`/AlumnoItem/${item.IdAlumno}`);" color="success" block><v-icon>check</v-icon> Seleccionar</v-btn></v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-title><v-btn @click="$router.push(`/MatriculaByAlumno/${item.IdAlumno}`);" color="info" block><v-icon>bookmark</v-icon> Matricular</v-btn></v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-title><v-btn @click="fuPagoEnLinea(item.IdAlumno)" color="orange" block dark><v-icon>attach_money</v-icon> Pago en Linea</v-btn></v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="ssUser.Usuario=='larenas' || ssUser.Usuario=='cquispeh' || ssUser.Usuario=='isaavedra' || ssUser.Usuario=='eccarhuarupay' || ssUser.Usuario=='lferro' || ssUser.Usuario=='cloaiza'">
                            <v-list-item-title><v-btn @click="fuPriAlumnosServicioCambioOpen(item)" color="red" block dark><v-icon>rocket_launch</v-icon> Cambio Carrera</v-btn></v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>            
            <template v-slot:[`item.Alumno`]="{ item }">
                <v-btn @click="$router.push(`/AlumnoItem/${item.IdAlumno}`);" color="success" text>{{item.Alumno}}</v-btn>
            </template>
            <template v-slot:[`item.Celular`]="{ item }">
                {{ item.Celular }} - {{ item.Telefono }}
            </template>
        </v-data-table>
        <v-dialog v-model="dDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="fuPriAlumnosServicioCambioClose"><v-icon>close</v-icon></v-btn>
                    <v-toolbar-title>Cambio de Carrera</v-toolbar-title>
                </v-toolbar>
                <PriAlumnosServicioCambio ref="refPriAlumnosServicioCambio" :pPriAlumno="dPriAlumno"/>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="dSnackbar" color="red">Revise el formulario, existe datos erróneos.
            <v-btn text @click="dSnackbar = false"> Cerrar </v-btn>
        </v-snackbar>
    </v-card>    
</template>

<script>
import gql from 'graphql-tag';
import {mapState} from 'vuex';
import PriAlumnosServicioCambio from '@/components/Academico/PriAlumnosServicioCambio'

export default {
    name: 'Alumno',
    components: {
        PriAlumnosServicioCambio
    },
    data: () => ({
        dSnackbar: false,
        dPriAlumnos: [],
        dDNINombre:'',// 20201A140 75825839
        dTable: {
            headers: [
                {value: 'actions', text: '...', sortable: false},
                {value: 'Alumno', text: 'Alumno'},
                {value: 'DNI', text: 'DNI', align: 'center', sortable: false},
                {value: 'Codigo', text: 'Codigo'},
                {value: 'IdServicio', text: 'IdServicio', align: ' d-none'},
                {value: 'priservicio.Iniciales', text: 'Carrera', align: 'center', sortable: false},
                {value: 'Celular', text: 'Celular', align: 'center', sortable: false},
                {value: 'Direccion', text: 'Direccion', sortable: false},
                {value: 'IdAlumno', text: 'id'},
            ],
            loading: false,
            search: null,
        },
        dDialog: false,
        dPriAlumno: null
    }),
    computed: {
        ...mapState(['ssUser']),
        campoTipo: function () {
            if(this.dDNINombre==''){
                return '';
            } else {
                if(this.dDNINombre.length==8 && !isNaN(this.dDNINombre))
                    return 'DNI';
                else{
                    if(this.dDNINombre.length==9 && !isNaN(this.dDNINombre.substring(0,5)))
                        return 'Codigo';
                    else
                        return 'Nombre';
                }
            }
        }
    },
    methods: {
        fuSearch(){
            if(this.dDNINombre==''){
                this.dSnackbar = true;
            } else {
                if(this.dDNINombre.length==8 && !isNaN(this.dDNINombre))
                    this.fuPrialumnoByDNI(this.dDNINombre)
                else{
                    if(this.dDNINombre.length==9 && !isNaN(this.dDNINombre.substring(0,5)))
                        this.fuPrialumnoByCodigo(this.dDNINombre)
                    else
                        this.fuPrialumnoByAlumno(this.dDNINombre)
                }
            }
        },
        async fuPrialumnoByCodigo(pCodigo) {
            this.dTable.loading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query prialumnoByCodigo($Codigo: String!, $token: String){
                        prialumnoByCodigo(Codigo: $Codigo, token: $token){
                            IdAlumno
                            Alumno
                            DNI
                            Codigo
                            IdServicio
                            Celular
                            Telefono
                            Direccion
                            Sexo
                            priservicio{
                                Iniciales
                            }
                        }
                    }`,
                    variables: {
                        Codigo: pCodigo,
                        token: new Date().toISOString()
                    }
                })
                console.log(response.data.prialumnoByCodigo);
                this.dPriAlumnos = [];
                this.dPriAlumnos.push(response.data.prialumnoByCodigo);
            } catch (error) {
                console.log(error);
            } finally {
                this.dTable.loading = false
            }
        },
        async fuPrialumnoByDNI(pDni) {
            this.dTable.loading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query prialumnoByDNI($DNI: String!, $token: String){
                        prialumnoByDNI(DNI: $DNI, token: $token){
                            IdAlumno
                            Alumno
                            DNI
                            Codigo
                            IdServicio
                            Celular
                            Telefono
                            Direccion
                            Sexo
                            priservicio{
                                Iniciales
                            }
                        }
                    }`,
                    variables: {
                        DNI: pDni,
                        token: new Date().toISOString()
                    }
                })
                console.log(response.data.prialumnoByDNI);
                this.dPriAlumnos = response.data.prialumnoByDNI;
            } catch (error) {
                console.log(error);
            } finally {
                this.dTable.loading = false
            }
        },
        async fuPrialumnoByAlumno(pAlumno) {
            this.dTable.loading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query prialumnoByAlumno($Alumno: String!, $token: String){
                        prialumnoByAlumno(Alumno: $Alumno, token: $token){
                            IdAlumno
                            Alumno
                            DNI
                            Codigo
                            IdServicio
                            Celular
                            Telefono
                            Direccion
                            Sexo
                            priservicio{
                                Iniciales
                            }
                        }
                    }`,
                    variables: {
                        Alumno: pAlumno,
                        token: new Date().toISOString()
                    }
                })
                this.dPriAlumnos = response.data.prialumnoByAlumno;
            } catch (error) {
                console.log(error);
            } finally {
                this.dTable.loading = false
            }
        },
        fuPagoEnLinea(pIdAlumno){
            let vRandom = new Date().toISOString();
            let vUrl = "https://pagos.khipu.edu.pe/ResumenPagos/1/"+pIdAlumno+"/"+vRandom;
            window.open(vUrl, '_blank');
        },
        fuPriAlumnosServicioCambioOpen(aItem){
            this.dDialog = true;
            this.dPriAlumno = aItem;
            //this.$refs.refPriAlumnosServicioCambio.fuLoad("hola");
            // window.setTimeout(function() {
            //     alert("Hello World!");
            //     //this.$refs.refPriAlumnosServicioCambio.fuLoad("hola");
            // }, 5000);
        },
        fuPriAlumnosServicioCambioClose(){
            this.dDialog = false;
            this.dPriAlumno = null;
        }
    },
}
</script>